import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "link"
    }}>{`Link`}</h1>
    <p>{`A link to a placed file.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`AFTER_NEW`}</strong>{` = afterNew`}</p>
      <p parentName="blockquote">{`Dispatched after a Link is created. This event bubbles. This event is not cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`BEFORE_DELETE`}</strong>{` = beforeDelete`}</p>
      <p parentName="blockquote">{`Dispatched before a Link is deleted. This event bubbles. This event is cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`AFTER_DELETE`}</strong>{` = afterDelete`}</p>
      <p parentName="blockquote">{`Dispatched after a Link is deleted. This event bubbles. This event is not cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`BEFORE_UPDATE`}</strong>{` = beforeUpdate`}</p>
      <p parentName="blockquote">{`Dispatched before a Link is updated. This event bubbles. This event is cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`AFTER_UPDATE`}</strong>{` = afterUpdate`}</p>
      <p parentName="blockquote">{`Dispatched after a Link is updated. This event bubbles. This event is not cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`BEFORE_EMBED`}</strong>{` = beforeEmbed`}</p>
      <p parentName="blockquote">{`Dispatched before a Link is embedded. This event bubbles. This event is cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`AFTER_EMBED`}</strong>{` = afterEmbed`}</p>
      <p parentName="blockquote">{`Dispatched after a Link is embedded. This event bubbles. This event is not cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`BEFORE_UNEMBED`}</strong>{` = beforeUnembed`}</p>
      <p parentName="blockquote">{`Dispatched before a Link is unembedded. This event bubbles. This event is cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`AFTER_UNEMBED`}</strong>{` = afterUnembed`}</p>
      <p parentName="blockquote">{`Dispatched after a Link is unembedded. This event bubbles. This event is not cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`BEFORE_MOVE`}</strong>{` = beforeMove`}</p>
      <p parentName="blockquote">{`Dispatched before a Link is relocated from one object to another. This event bubbles. This event is cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`AFTER_MOVE`}</strong>{` = afterMove`}</p>
      <p parentName="blockquote">{`Dispatched after a Link is relocated from one object to another. This event bubbles. This event is not cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`AFTER_ATTRIBUTE_CHANGED`}</strong>{` = afterAttributeChanged`}</p>
      <p parentName="blockquote">{`Dispatched when the value of a property changes on this Link. This event bubbles. This event is not cancelable.`}</p>
    </blockquote>
    <h2 {...{
      "id": "instance"
    }}>{`Instance`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`VersionState `}<strong parentName="p">{`versionState`}</strong>{` `}</p>
      <p parentName="blockquote">{`The Version Cue version state of the file.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`EditingState `}<strong parentName="p">{`editingState`}</strong>{` `}</p>
      <p parentName="blockquote">{`The Version Cue editing state of the file.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`LinkMetadata `}<strong parentName="p">{`linkXmp`}</strong>{` `}</p>
      <p parentName="blockquote">{`XMP data for the link source file.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`index`}</strong>{` `}</p>
      <p parentName="blockquote">{`The index of the link in the links collection.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`parent`}</strong>{` `}</p>
      <p parentName="blockquote">{`The linked object. Can return: Story, Graphic, Movie or Sound.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`assetURL`}</strong>{` `}</p>
      <p parentName="blockquote">{`The asset URL of the linked object.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`assetID`}</strong>{` `}</p>
      <p parentName="blockquote">{`The asset ID of the linked object.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`edited`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, indicates the linked object has been edited in the current document but the source file has not been updated.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`name`}</strong>{` `}</p>
      <p parentName="blockquote">{`The name of the Link.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`needed`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, indicates a link to a full-resolution version of the source file is needed. If false, indicates the object is embedded.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`LinkStatus `}<strong parentName="p">{`status`}</strong>{` `}</p>
      <p parentName="blockquote">{`The status of the link.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`linkType`}</strong>{` `}</p>
      <p parentName="blockquote">{`The file type of the linked object.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Date `}<strong parentName="p">{`date`}</strong>{` `}</p>
      <p parentName="blockquote">{`The date and time the Link was created.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`size`}</strong>{` `}</p>
      <p parentName="blockquote">{`The size of the Link file.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`LinkResourceRenditionType `}<strong parentName="p">{`renditionData`}</strong>{` `}</p>
      <p parentName="blockquote">{`The rendition data of the link resource.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`linkResourceURI`}</strong>{` `}</p>
      <p parentName="blockquote">{`The URI of the linked resource.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`filePath`}</strong>{` `}</p>
      <p parentName="blockquote">{`The file path (colon delimited on the Mac OS). Can also accept: File.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`id`}</strong>{` `}</p>
      <p parentName="blockquote">{`The unique ID of the Link.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`isValid`}</strong>{` `}</p>
      <p parentName="blockquote">{`Returns true if the object specifier resolves to valid objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Events `}<strong parentName="p">{`events`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of events.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`EventListeners `}<strong parentName="p">{`eventListeners`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of event listeners.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Preferences `}<strong parentName="p">{`preferences`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of preferences objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Links `}<strong parentName="p">{`links`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of links.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`label`}</strong>{` `}</p>
      <p parentName="blockquote">{`A property that can be set to any string.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Object `}<strong parentName="p">{`properties`}</strong>{` `}</p>
      <p parentName="blockquote">{`A property that allows setting of several properties at the same time.`}</p>
    </blockquote>
    <h3 {...{
      "id": "methods"
    }}>{`Methods`}</h3>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`checkIn`}</strong>{`( String `}<strong parentName="p">{`versionComments`}</strong>{`, Boolean `}<strong parentName="p">{`forceSave`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Check in to Version Cue.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`versionComments`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The comment for this version (Optional)`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`forceSave`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Forcibly save a version (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`relink`}</strong>{`( Mixed `}<strong parentName="p">{`to`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Points the link to a new source file.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-1"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`to`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The full path name of the new source file. Can accept: File or String.`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`unlink`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Embeds the source file in the document.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Link `}<strong parentName="p">{`update`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Updates the link if the source file has been changed.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><strong parentName="p">{`unembed`}</strong>{`( File `}<strong parentName="p">{`to`}</strong>{`, String `}<strong parentName="p">{`versionComments`}</strong>{`, Boolean `}<strong parentName="p">{`forceSave`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Unembeds the source file. If no folder is specified, creates a link to the original source file; if a folder is specified, copies the file to the folder and creates a link to the copied file.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-2"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`File`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`to`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The folder to which to copy the unembedded file. (Optional)`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`versionComments`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The comment for this version. (Optional)`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`forceSave`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`If true, forcibly saves a version. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`replaceWithOriginal`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Experimental: Download the original asset and replace FPO with it.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><strong parentName="p">{`relinkTextFragmentLink`}</strong>{`( String `}<strong parentName="p">{`linkResourceURI`}</strong>{`, String `}<strong parentName="p">{`name`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Experimental: Relink the text fragment link to a new uri`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-3"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`linkResourceURI`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Resource URI to relink to.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`name`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The tag name for the key. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`reinitLink`}</strong>{`( String `}<strong parentName="p">{`linkResourceURI`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Experimental: Reinitialize the link to a new uri`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-4"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`linkResourceURI`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Resource URI to relink.`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`editOriginal`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Opens the source file of the link in the default editor for the source file type.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><strong parentName="p">{`show`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Selects the link.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><strong parentName="p">{`revealInSystem`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Opens the file system to the folder that contains the source file of the link, and selects the file.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><strong parentName="p">{`revealInBridge`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Opens Adobe Bridge and selects the source file of the link.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><strong parentName="p">{`copyLink`}</strong>{`( File `}<strong parentName="p">{`to`}</strong>{`, String `}<strong parentName="p">{`versionComments`}</strong>{`, Boolean `}<strong parentName="p">{`forceSave`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Copies the link file to the specified location.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-5"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`File`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`to`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The file or folder to which to copy the file.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`versionComments`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The comment for this version. (Optional)`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`forceSave`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`If true, forcibly saves a version. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`goToSource`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Opens the source file of the link in InDesign for SharedContent links.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><strong parentName="p">{`insertLabel`}</strong>{`( String `}<strong parentName="p">{`key`}</strong>{`, String `}<strong parentName="p">{`value`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Sets the label to the value associated with the specified key.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-6"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`key`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The key.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`value`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The value.`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`extractLabel`}</strong>{`( String `}<strong parentName="p">{`key`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Gets the label value associated with the specified key.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-7"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`key`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The key.`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSource`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Generates a string which, if executed, will return the Link.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Link `}<strong parentName="p">{`getElements`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Resolves the object specifier, creating an array of object references.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSpecifier`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Retrieves the object specifier.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`EventListener `}<strong parentName="p">{`addEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Adds an event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-8"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`removeEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Removes the event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-9"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      